



























































































































































import { Component, Vue } from "vue-property-decorator";
import { Toast, Swipe, SwipeItem } from "vant";
import request from "@/api/jiangjin/index";
import { wxChatShare, wxChatJumpApp } from "@/common/wechat";
import Videojs from "video.js";
import native from "@/common/Native";
import "video.js/dist/video-js.css";
import Base from "@/template/public/Base.vue";
import Openapp from "@/components/openApp.vue";
import AppPrompt from "@/components/AppPrompt.vue";
import nopage from "@/components/newchongqing404.vue";
import { getData, time } from "@/common/dataCollect";
@Component({
  filters: {
    praiseNum(num: number) {
      const number = Number(num);
      if (isNaN(number)) return num;
      if (number >= 10000) {
        return (number / 10000).toFixed(2) + "w";
      } else {
        return number;
      }
    }
  },
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    Openapp,
    AppPrompt,
    nopage
  }
})
export default class VerticalVideo extends Base {
  private videoDetail: any = null;
  private id: string = "";
  public request = new request();
  private state: boolean = false;
  private url: string = "";
  private img: string = "";
  private bg: string = "0.5";
  isPraise: boolean = false;
  public appId: string = "";
  private isOpenInApp: boolean = false;
  private userInfo: any = {
    token: "",
    sessionId: "",
    phone: ""
  };
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  is404 = false;
  isNewOpenApp = false; //是否显示微信唤醒的按钮
  extinfo: any = ""; //微信传参
  get commentImg() {
    return require("../../../assets/形状 29.png");
  }
  get praiseImg() {
    if (this.isPraise) {
      return require("@/assets/已点赞@2x.png");
    } else {
      return require("../../../assets/形状 27 拷贝 2.png");
    }
  }

  get shareImg() {
    return require("@/assets/分享@2x.png");
  }

  get sliderColor() {
    return "#d50017";
  }
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  mounted() {
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "2273453";
    this.appId = (this.$route.query.appId as string) || "1";
    //获取用户详情
    if (native.isOpenInApp()) {
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getDetail();
        this.isOpenInApp = true;
      });
    } else {
      this.getDetail();
      this.isOpenInApp = false;
      // this.isNewOpenApp = (this.$refs.newopenapp as any).isShowWXbtn;
    }
    // this.isNewOpenApp = (this.$refs.newopenapp as any).isShowWXbtn;
  }

  getDetail() {
    this.request
      .getInfoVideoDetails(this.appId, this.infoClassifyId)
      .then(response => {
        if (response.code >= 0) {
          this.videoDetail = response.data;
          document.title = this.videoDetail.title;
          this.getBussinessDetail();
          this.getShareInfo(this.appId);
          this.detailGetAppId = this.videoDetail.appId;
          this.$nextTick(() => {
            this.initVideo();
          });
          let params = {
            contextType: 5, // contextType 竖版视频传5  多图新闻传1 其他的也传1
            detailViewType: "2", // 写死传2
            id: this.videoDetail.id, //新闻id
            videoFormat: "2", //  videoFormat竖屏新闻传2  别的为-1
            shareUrl: this.videoDetail.contentUrl, //新闻url
            url: this.videoDetail.contentUrl, // 新闻url
            sourceId: this.videoDetail.infoClassifyId, // sourceId
            sourceType: "", // sourceType空字符串
            thirdUrlEncode: false,
            title: "", // title空字符串
            shareTitle: "" // shareTitle空字符串
          };
          this.extinfo = JSON.stringify(params);
          this.$nextTick(() => {
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.videoDetail);
              this.dataSource = false;
            }
          });
        } else {
          this.getShareInfo(this.appId);
          this.is404 = true;
        }
      })
      .catch(() => {
        this.getShareInfo("1");
        this.is404 = true;
      });
  }
  //初始化video
  async initVideo() {
    var _this = this;
    let myPlayer = Videojs(
      document.getElementById("myVideo"),
      {
        //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        controls: true,
        //自动播放属性,muted:静音播放
        autoplay: false,
        //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        preload: "auto",
        // poster: this.videoDetail.videoImg,
        loop: false,
        // poster: this.img,
        playsinline: true,
        // 控制器空间显示与否
        controlBar: {
          // playToggle:false, // 播放按钮
          // fullscreenToggle: false,  // 全屏按钮
          // volumePanel: false,  // 音量控制
          children: [
            {
              name: "progressControl"
            }
          ]
        },
        sources: {
          src: this.videoDetail.contentUrl,
          type: "video/mp4"
        }
      },
      function() {
        myPlayer.on("ended", function() {
          console.log("ended");
          let play = document.getElementById("playImg") as HTMLImageElement;
          play.style.opacity = "1";
          _this.state = false;
        });
      }
    );
    var btn = document.getElementsByClassName(
      "vjs-big-play-button"
    )[0] as HTMLButtonElement;
    btn.style.opacity = "0";
    var bar = document.getElementsByClassName(
      "vjs-control-bar"
    )[0] as HTMLButtonElement;
    bar.style.opacity = "1";
    bar.style.backgroundColor = "transparent";
    let play = document.getElementById("playImg") as HTMLImageElement;
    play.style.opacity = "1";
    let posterImg = document.getElementById("posterImg") as HTMLImageElement;
    posterImg.style.opacity = "1";
    let sliderBar = document.getElementsByClassName(
      "vjs-slider-bar"
    )[0] as HTMLImageElement;
    sliderBar.style.backgroundColor = this.sliderColor;
    sliderBar.style.zIndex = "10000";
    let slider = document.getElementsByClassName(
      "vjs-slider"
    )[0] as HTMLImageElement;
  }
  //点击视频
  handle() {
    var myPlayer = Videojs(document.getElementById("myVideo"));
    var meng = document.getElementById("meng") as HTMLDivElement;
    let play = document.getElementById("playImg") as HTMLImageElement;
    let posterImg = document.getElementById("posterImg") as HTMLImageElement;
    let stop = document.getElementById("playStop") as HTMLImageElement;
    //视频在播放时
    if (this.state) {
      myPlayer.pause(); //暂停
      console.log("暂停");
      meng.style.zIndex = "1";
      meng.style.backgroundColor = "rgba(255, 255, 255, 0)";
      play.style.opacity = "1";
      posterImg.style.opacity = "0";
      stop.style.opacity = "0";
      this.state = false;
    } else {
      myPlayer.play(); //播放视频
      console.log("播放");
      meng.style.zIndex = "";
      play.style.opacity = "0";
      posterImg.style.opacity = "0";
      stop.style.opacity = "1";
      this.state = true;
      setTimeout(() => {
        stop.style.opacity = "0";
      }, 1500);
    }
  }
  //点击右边三个按键跳下载页面
  download() {
    window.location.href = this.shareInfo.downloadUrl;
  }
  //分享
  share() {}

  async getIsPraise() {
    const result = await this.request.isPraised(
      this.appId,
      this.userInfo.sessionId,
      this.userInfo.token,
      "1",
      this.videoDetail!.informationId,
      "1"
    );
    this.isPraise = result.data;
  }

  doPraiseShare() {
    if (!native.isOpenInApp()) {
      return this.download();
    }
    if (this.isPraise) {
      return;
    }
    this.request
      .doPraise(
        this.infoClassifyId,
        this.appId,
        this.userInfo.sessionId,
        this.videoDetail!.informationId,
        "1",
        "1",
        0,
        this.userInfo.token,
        new Date().format()
      )
      .then((result: any) => {
        if (result.data.isSuccess) {
          isNaN(Number(this.businessDetail!.praiseCount))
            ? ""
            : (this.businessDetail!.praiseCount =
                Number(this.businessDetail!.praiseCount) + 1);
          this.isPraise = true;
        } else {
          Toast(result.data.message);
        }
      });
  }

  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.infoClassifyId,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          this.isPraise = response.data.isPraised;
          this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }

  toDetails() {
    location.href = this.videoDetail.url;
  }

  // wx标签初始化完毕，可以进行点击操作
  handleReadyFn(e: any) {
    console.log("初始化成功", e);
  }
  // wx标签用户点击跳转按钮并对确认弹窗进行操作后触发
  handleLaunchFn(e: any) {
    console.log("success", e);
    console.log("mu222");
  }
  // wx标签用户点击跳转按钮后出现错误
  handleErrorFn(e: any) {
    console.log("fail", e.detail);
    console.log(e);
    console.log("如果是没安装应用, 则跳转下载页");
    (this.$refs.newopenapp as any).handleErrorFn();
  }
}
